import { FieldArray, useField } from "formik";
import { Fragment } from "react";
import styled from "styled-components";
import { TenantOptionResource } from "../../../shared/types/tenant";
import { useSidebarData } from "../shared/api/sidebarService";
import { CarFleetStatusSelect } from "./CarFleetStatusSelect";
import { EventPrioritySelect } from "./EventPrioritySelect";

const Wrapper = styled.div<{ $columns: string }>`
	display: grid;
	grid-template-columns: ${({ $columns }) => $columns};
	gap: ${({ theme }) => theme.spacing(4)};
	padding-top: ${({ theme }) => theme.spacing(2)};
`;

const Title = styled.div`
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: ${({ theme }) => theme.colors.palette.black};
	font-size: ${({ theme }) => theme.fonts.sizes.normal};
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

export const CompanyDrawerFormTenantFields = () => {
	const { sidebarData } = useSidebarData();
	const [{ value: tenants }] = useField<TenantOptionResource[]>("tenants");

	return (
		<FieldArray
			name="pivotValues"
			render={(props) => (
				<>
					{tenants.map((tenant, index) => (
						<Fragment key={index}>
							<Title>{tenant.name}</Title>
							<Wrapper $columns={sidebarData?.applications?.carFleets?.length ? "1fr 1fr" : "1fr"}>
								<EventPrioritySelect name={`${props.name}[${tenant.id}].eventPriority`} />
								{(sidebarData?.applications?.carFleets?.length || 0) > 0 && (
									<CarFleetStatusSelect name={`${props.name}[${tenant.id}].carFleetStatus`} required />
								)}
							</Wrapper>
						</Fragment>
					))}
				</>
			)}
		/>
	);
};
